import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=024972b0&scoped=true&"
import script from "./InputField.vue?vue&type=script&lang=js&"
export * from "./InputField.vue?vue&type=script&lang=js&"
import style0 from "./InputField.vue?vue&type=style&index=0&id=024972b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024972b0",
  null
  
)

export default component.exports